module.exports = __webpack_public_path__ + "img/blockquote-left.3a55370a.svg";